import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EuroSymbolOutlinedIcon from '@mui/icons-material/EuroSymbolOutlined';
import RendersIcons from '../componets/RednersIcons'
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import ListItemAvatar from '@mui/material/ListItemAvatar';


const CustomListItem = withStyles({
  root: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: "#71c775",
    height: 57
  }
})(ListItem);

const CustoButton = withStyles({
  root: {
    color: "#000",
    height: 57,
  }
})(Button);

const CustomCssBaseline = withStyles({
  height: '12%'
})(CssBaseline);

export default function Cart(props) {
  const toggleDrawer = (isOpen) => (event) => {
    props.setOpenCart(isOpen)
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'right' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
    //   onClick={toggleDrawer(false)}
    //   onKeyDown={toggleDrawer(false)}
    >
      <Divider />
      <List key={0}>
        {props.isOpenCart ? renderCart() : ""}
      </List>
    </Box>
  );
  const ref = React.useRef(null);

  const renderCart = () => {
    var list = []
    Array.from(props.cart.keys()).map(key => {
      if (key != "order_info") {
        let value = props.cart.get(key)
        var tot = value.quantity * value.price
        allPrice = allPrice + tot
        if (tot != 0) {
          list.push(
            <ListItem key={key} sx={{
              '& .MuiListItemIcon-root': { color: '#000' }
            }}>
              <ListItemIcon>
                <RendersIcons title={value.title} />
              </ListItemIcon>
              <ListItemText
                primary={key}
                secondary={value.price + "€ X " + value.quantity + " = " + tot + "€"}
              />
            </ListItem>
          )
        }
      }
    });


    list.push(
      <div style={{ height: 60, width: '100%' }}>
      </div>
    )
    list.push(
      <CustomListItem elevation={3} sx={{
        '& .MuiListItemIcon-root': { color: '#000' }
      }}>
        <ListItemIcon>
          <EuroSymbolOutlinedIcon />
        </ListItemIcon>
        <CustoButton >
          <ListItemText
            primary="Totale"
            secondary={allPrice}
          />
        </CustoButton>
      </CustomListItem>
    )
    return list
  }
  let allPrice = 0
  return (
    <React.Fragment key="Cart">
      <Drawer
        anchor={"right"}
        open={props.isOpenCart}
        onClose={() => props.setOpenCart(false)}
      >
        {list("anchor")}
      </Drawer>
    </React.Fragment>
  );
}